/* eslint-disable @typescript-eslint/camelcase */

enum MarketingParam {
  LANDING_URL = 'landing_url',
  MEDIA_SOURCE = 'media_source',
  MARKETING_MEDIUM = 'marketing_medium',
  CAMPAIGN_NAME = 'campaign_name',
  CAMPAIGN_ID = 'campaign_id',
  ADSET_NAME = 'adset_name',
  ADSET_ID = 'adset_id',
  AD_NAME = 'ad_name',
  AD_ID = 'ad_id',
  FBC = 'fbc',
  FBP = 'fbp',
  PUBLISHER = 'publisher',
}

const MARKETING_SEARCH_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_campaign_id',
  'utm_adset',
  'utm_adset_id',
  'utm_content',
  'utm_ad_id',
  'fbclid',
  'gclid',
  'publisher',
];

const MARKETING_PARAMS_MAPPING: Dictionary<string> = {
  utm_source: MarketingParam.MEDIA_SOURCE,
  utm_medium: MarketingParam.MARKETING_MEDIUM,
  utm_campaign: MarketingParam.CAMPAIGN_NAME,
  utm_campaign_id: MarketingParam.CAMPAIGN_ID,
  utm_adset: MarketingParam.ADSET_NAME,
  utm_adset_id: MarketingParam.ADSET_ID,
  utm_content: MarketingParam.AD_NAME,
  utm_ad_id: MarketingParam.AD_ID,
};

export { MarketingParam, MARKETING_SEARCH_PARAMS, MARKETING_PARAMS_MAPPING };
